/*
 * @Author: 刑天
 * @Date: 2022-04-15 10:18:49
 * @LastEditTime: 2024-01-10 11:26:23
 * @Description: 战神
 */
import * as appointActivity from '../services/appointActivity';

export default {
  namespace: 'appointActivity',

  state: {
    appointActivityList: [],
    total: 1,
  },

  effects: {
    *getAppointActivity({ payload: { values } }, { call, put }) {
      const response = yield call(
        appointActivity.getAppointActivityList,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          appointActivityList: response?.data?.data,
          total: response?.data?.total,
        },
      });
    },
    *terminateActivityBooking({ payload: { values }, callback }, { call }) {
      const response = yield call(
        appointActivity.terminateActivityBooking,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *approveActivityBooking({ payload: { values }, callback }, { call }) {
      const response = yield call(
        appointActivity.approveActivityBooking,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *deleteActivityBooking({ payload: { values }, callback }, { call }) {
      const response = yield call(
        appointActivity.deleteActivityBooking,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
